
import { Card, Col, Container, Row } from 'react-bootstrap';
import { FaUsers } from 'react-icons/fa';
import { BsBuildings } from 'react-icons/bs';
import { BiSolidBuildingHouse } from 'react-icons/bi';
import { HiOutlineBuildingStorefront } from 'react-icons/hi2';
const Benefit = () => {
  return (
    <Container className="my-5">
      <h2 className="text-center fw-bold mb-5 want-test__titl">Benefits</h2>
      <div className="container-small">
     
        <Row className="text-start">
          <Col md={6}>
            <p>
              Use your new Yard Sign Lead Generation System to impress potential
              listing clients. You can tell them that the response rate is up to
              4x higher and you follow up with EVERY LEAD within seconds to help
              them get their house sold FAST!
            </p>
          </Col>
          <Col md={6}>
            <p>
              Never print another yard sign paper flyer. We all know what
              happens to these right? They end up being strewn around the
              neighborhood by nosy neighbors or hooligans anyway and the cost of
              printing them is probably about as much or more as our system.
              Really, let’s save some trees and keep the neighborhood clean.
            </p>
          </Col>
        </Row>

        <Row className="mt-4 g-3 text-start">
          <Col md={3}>
            <Card className="text-center p-3 shadow-sm h-100">
              <Card.Body>
                <FaUsers style={{ color: '#5bb000', fontSize: '3rem' }} />
                <Card.Text className="text-justify mt-2">
                  All leads are stored in your online account so you can keep
                  track of who has called what listing and when.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center p-3 shadow-sm h-100">
              <Card.Body>
                <BsBuildings style={{ color: '#5bb000', fontSize: '3rem' }} />
                <Card.Text className="text-justify mt-2">
                  The sign riders are re-usable! Whenever you get a new listing,
                  simply log into your online account and assign the property to
                  the yard sign you want to use.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center p-3 shadow-sm h-100">
              <Card.Body>
                <BiSolidBuildingHouse
                  style={{ color: '#5bb000', fontSize: '3rem' }}
                />
                <Card.Text className="text-justify mt-2">
                  More sign riders are available to you at any time and are sold
                  in 4 packs for $60 and ship within 24 hours! Simply order them
                  from within your online account.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center p-3 shadow-sm h-100">
              <Card.Body>
                <HiOutlineBuildingStorefront
                  style={{ color: '#5bb000', fontSize: '3rem' }}
                />
                <Card.Text className="text-justify mt-2">
                  This is the most cost-effective way of capturing 4x more yard
                  sign leads and ultimately leads to MORE CLIENTS with minimal
                  set-up time and effort on your part.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Final Text Section */}
        <Row className="mt-4 text-start">
          <Col md={{ span: 10, offset: 2 }}>
            <p>
              Sound good? Sign up now and we will ship your yard signs out
              within 24 hours. <br /> That’s it! You will receive up to 4x more
              responses than a standard yard sign alone and land more clients.
            </p>
          </Col>
        </Row>

        <p className="text-center fw-bold">
          No Contracts, No Hidden Fees, Unlimited Use!
        </p>
      </div>
    </Container>
  );
};

export default Benefit;
